import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

import { consts } from '@src/constants/consts';
import { MultiRollbackPackageDialogData } from './multi-rollback-package-dialog.data';
import { MultiRollbackPackageDataSource } from './multi-rollback-package.data-source';

import _ from 'lodash';

@Component({
    selector : 'multi-rollback-package-dialog',
    template: require('./multi-rollback-package-dialog.component.html'),
    styles: [require('./multi-rollback-package-dialog.component.scss')]
})
export class MultiRollbackPackageDialogComponent implements OnInit, OnDestroy {
    public delayShowAvailable = true;
    public isCollapsedSelected = true;
    public isCollapsedAvailable = true;
    public selectedPackageType = false;
    public selectedFilterOption: string;
    public filterText: string;
    public filterOptions: any[];
    public availablePackages: MultiRollbackPackageDataSource;
    public showAvailablePackages = false;
    
    private defaultOrderSelectedPackages = true;

    constructor(
        private dialogRef: MatDialogRef<MultiRollbackPackageDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MultiRollbackPackageDialogData) {
        this.selectedFilterOption = consts.FilterOption.Package_Or_Tag.toString();
        const arrOptions = [];
        for (const x in consts.FilterOption) {
            arrOptions.push({ key: x.replace(new RegExp('_', 'g'), ' '), value: consts.FilterOption[x] });
        }
        this.filterOptions = arrOptions;
       
    }

    public async ngOnInit() {
        this.data.autoBackupSelected = this.data.autoBackUpItems[0].Key.toString();
        this.data.autoRestoreSelected = this.data.autoRestoreItems[0].Key.toString();

        const filterText = this.filterText ? this.filterText : '';
        this.availablePackages = new MultiRollbackPackageDataSource(
            this.data, filterText, this.selectedFilterOption, this.selectedPackageType);
        await this.availablePackages.reset(filterText, this.selectedFilterOption, this.selectedPackageType);
        this.showAvailablePackages = true;
    }

    public ngOnDestroy() {
        this.showAvailablePackages = false;
        this.availablePackages.disconnect();
    }

    public async onSplitChanged() {
        this.ngOnDestroy();
        await this.ngOnInit();
    }

    public onRemovePackage(pack: any, from: any, to: any, reorderRequired: any) {
        if (to === this.data.packages.selectedPackages && to.length === 0) {
            this.defaultOrderSelectedPackages = true;
        }

        if (!this.defaultOrderSelectedPackages && to === this.data.packages.selectedPackages) {
            pack.order = Math.max(...to.map((x: any) => x.order), 0) + 1;
        }

        to.push(pack);
        const index = from.indexOf(pack);
        if (index !== -1) {
            from.splice(index, 1);
        }
        if (reorderRequired === true
            && (this.defaultOrderSelectedPackages || to === this.availablePackages)) {
            this.restoreOrder(true, to);
        }
    }

    public getTags(pack: any) {
        if (pack.tags)
            return pack.tags.map((x: any) => x.name).join(', ');
    }

    public transferAll(from: any, to: any) {
        let i = from.length;
        const reversedFrom = from.reverse();
        while (i--) {
            this.onRemovePackage(reversedFrom[i], reversedFrom, to, false);
        }
        from.splice(0, from.length);
        if (this.defaultOrderSelectedPackages || to === this.availablePackages) {
            this.restoreOrder(true, to);
        }
    }

    public restoreOrder(isForcedDefault: any, packages: any) {
        if (isForcedDefault === true) {
            packages.forEach((x: any) => { x.order = this.availablePackages.defaultSort.find(y => y.id === x.id).order; });
        }
        packages.sort((a: any, b: any) => parseInt(a.order, 10) - parseInt(b.order, 10));
    }

    public async onFilterPackages() {
        const filterText = this.filterText ? this.filterText : '';
        await this.availablePackages.reset(filterText, this.selectedFilterOption, this.selectedPackageType);
    }

    public onSwitchOrder(pack: any, direction: any) {
        this.defaultOrderSelectedPackages = false;
        const packagesSelected = _.orderBy(this.data.packages.selectedPackages, ['order'], ['asc']);
        packagesSelected.forEach((elm: any, index: any) => { elm.order = index; });
        const { 0: nextPack } = direction > 0
            ? _.orderBy(packagesSelected.filter((m: any) => m.order < pack.order), ['order'], ['desc'])
            : _.orderBy(packagesSelected.filter((m: any) => m.order > pack.order), ['order'], ['asc']);

        if (nextPack) {
            const order = pack.order;
            pack.order = nextPack.order;
            nextPack.order = order;
            this.data.packages.selectedPackages = _.orderBy(packagesSelected, ['order'], ['asc']);
        }
    }

    public getPackageTypes() {
        const arrOptions = [];
        for (const x in consts.PackageType) {
            arrOptions.push({ key: x, value: consts.PackageType[x] });
        }
        return arrOptions;
    }

    public async onUpgrade() {
        this.dialogRef.close(this.data); 
    }

    public close() {
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/multi-rollback-package-dialog/multi-rollback-package-dialog.component.ts